import { useEffect } from 'react'
import { useAuth } from '../../hooks/use-auth/use-auth.hook'
import { getAuthConfig } from '../../services/auth-config/auth-config.service'

type TUseProtectedRouteReturn = {
  isLoading: boolean
  isAuthenticated: boolean
}

export const useProtectedRoute = (): TUseProtectedRouteReturn => {
  const { isAuthenticated, isLoading } = useAuth()

  useEffect(() => {
    if (!isLoading && !isAuthenticated && globalThis.location !== undefined) {
      const config = getAuthConfig()
      const returnUrl = encodeURIComponent(globalThis.location.href)
      globalThis.location.href = `${config.loginUrl}?r=${returnUrl}`
    }
  }, [isLoading, isAuthenticated])

  return { isLoading, isAuthenticated }
}
